import "./viewDataPage.css";
import { useEffect, useState } from "react";
import { JsonRpcProvider } from "ethers";
import { Box, Container } from "@mui/material";
import Top from "../../components/top/Top";
import DialogConfirm from "../../components/dialogConfirm/DialogConfirm";
import TableView from "../../components/tableView/TableView";
import { useHoldersList } from "../../hooks/useHoldersList";
import { useTotalHolders } from "../../hooks/useTotalHolders";

export const ViewDataPage = () => {
    const genProvider = new JsonRpcProvider(process.env.REACT_APP_RPC_PROVIDER);

    const totalHolers = useTotalHolders(genProvider);
    const { holderList, holderListAll, data, holderAll } = useHoldersList(genProvider);
    const [open, setOpen] = useState(false);
    const [page, setPage] = useState(0);

    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        holderList(10, page).catch(console.error)
    }, [page])

    useEffect(() => {
        holderListAll().catch(console.error)

    }, [])

    useEffect(() => {
        console.log('Data:', data)
        console.log('HolderAll:', holderAll)
    }, [data,holderAll])

    const handleChange = (event: any, newPage: any) => {
        setPage(newPage - 1);
    };

    return (
        <Box display="flex" flexDirection="column">
            <Top
                title="View"
                subTitle="Data"
                description="You can view Customer ID or User Data and download the report here"
            />
            <Container sx={{ maxWidth: '90vw !important' }}>
                <TableView
                    rows={data}
                    csvValue={holderAll}
                    page={page}
                    total={totalHolers}
                    handleClick={() => handleOpen()}
                    handleChangePage={handleChange}
                />
            </Container>
            {/* <DialogConfirm
                open={open}
                onClose={handleClose}
                title="Add"
                subTitle="Wallet Address"
                description="Enter wallet address in the field below to update the controller"
                address="0xdf456weih560387570endi3dpwk8y37gfeug095behrfiweh343B"
                confirm={() => { }}
            /> */}
        </Box>
    );
};

export default ViewDataPage;
